import { AppName } from "core/types";
import LanguageFab from "ds_legacy/components/FlagFab";
import { SpinnerPage } from "ds_legacy/components/Spinner";
import PrintOverlay from "dsl/atoms/PrintOverlay";
import { useEnvironmentSwitcher } from "dsl/hooks";
import useLoadFavicon from "dsl/hooks/useLoadFavicon";
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";

export default function RootPage({
  appName,
  children,
}: {
  appName: AppName;
  children?: React.ReactNode;
}) {
  useLoadFavicon();
  useEnvironmentSwitcher();

  return (
    <div className="flex min-h-screen flex-1 flex-col print:mx-4 print:block print:h-auto print:min-h-0 print:break-inside-avoid">
      <PrintOverlay />
      <LanguageFab />
      <Suspense
        fallback={
          <SpinnerPage height="100%" id={`suspense-router-${appName}`} />
        }
      >
        {children ?? <Outlet />}
      </Suspense>
    </div>
  );
}
